import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

const modules = [
  {
    title: "QR CODE SCAN",
    description: "Quickly bring customers to the checkout page via video.",
  },
  {
    title: "INCREASE CONVERSION RATES",
    description: "Generate leads and build brand trust.",
  },
  {
    title: "ON ORDER",
    description: "Click and order online products",
  },
];

const modulesRight = [
  {
    title: "START YOUR MOBILE VIDEO BUSINESS.",
    description: "",
  },
  {
    title: "TURN VIDEO INTO BRIDGE",
    description: "Link business and consumers with fun and convertible videos.",
  },
  {
    title: "MEMBER SIGN-UP",
    description: "All users can register for free.",
  },
];

function getOrientation() {
  if (typeof window === "undefined") return "horizontal";
  return window.innerHeight > window.innerWidth ? "vertical" : "horizontal";
}

const ModuleBlock: React.FC<{ title: string; description: string }> = ({
  title,
  description,
}) => {
  return (
    <div
      key={title}
      style={{
        background: "linear-gradient(135deg, #5ec6d6 0%, #357a8c 100%)",
        borderRadius: "18px",
        padding: "2rem 2.5rem",
        minWidth: "260px",
        maxWidth: "320px",
        boxShadow:
          "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
        color: "#fff",
        fontWeight: 500,
        fontSize: "1.25rem",
        marginBottom: "0.5rem",
      }}
    >
      <h2
        style={{
          color: "#222",
          fontWeight: 700,
          fontSize: "1.1em",
          marginBottom: "0.5em",
        }}
      >
        {title}
      </h2>
      <span style={{ color: "#222", fontSize: "1em", opacity: 0.85 }}>{description}</span>
    </div>
  );
};

const HomePage: React.FC = () => {
  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const handleResize = () => setOrientation(getOrientation());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mobile = orientation === "vertical";
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
      }}
    >
      {mobile ? (
        <div
          style={{
            position: "relative",
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#111827",
          }}
        >
          <iframe
            src="/promotion"
            title="Video Overlay"
            style={{
              width: "100vw",
              height: "100vh",
              border: "none",
              background: "#222",
            }}
            allow="autoplay"
          />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Header />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100vw",
              gap: "2vw",
              flexDirection: orientation === "horizontal" ? "row" : "column",
            }}
          >
            {/* Left modules */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2vw" }}
            >
              {modules.map((mod, idx) => (
                <ModuleBlock
                  key={mod.title}
                  title={mod.title}
                  description={mod.description}
                />
              ))}
            </div>

            {/* Center phone mockup */}
            <div
              style={{
                position: "relative",
                width:
                  orientation === "horizontal"
                    ? `${(window.innerHeight * 0.75 * 9) / 16}px`
                    : "90vw",
                height:
                  orientation === "horizontal"
                    ? `${window.innerHeight * 0.75}px`
                    : "60vh",
                background: "#111827",
                borderRadius: "40px",
                boxShadow:
                  "0 10px 30px 0 rgba(0,0,0,0.25), 0 1.5px 6px 0 rgba(0,0,0,0.10)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              <iframe
                src="/promotion"
                title="Video Overlay"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  borderRadius: "40px",
                  background: "#222",
                }}
                allow="autoplay"
              />
              {/* Phone notch */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "120px",
                  height: "28px",
                  background: "#222",
                  borderRadius: "0 0 16px 16px",
                  zIndex: 2,
                }}
              ></div>
            </div>

            {/* Right modules */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2vw" }}
            >
              {modulesRight.map((mod, idx) => (
                <ModuleBlock
                  key={mod.title}
                  title={mod.title}
                  description={mod.description}
                />
              ))}
            </div>
          </div>
          <Footer />
        </div>
      )}
    </div>
  );
};

export default HomePage;
